import { MultiSelect, Select } from '@mantine/core';
import React, { useMemo } from 'react';

import { useGetVersions } from 'api/versions';

type VersionSelectorProps = {
  projectId: string;
  orgId: string;
  value: string[];
  onChange: (versions: string[]) => void;
  placeholder?: string;
  label?: string;
  disabled?: boolean;
  multiple?: boolean;
  archived?: boolean;
};

export function VersionSelector({
  projectId,
  orgId,
  value,
  onChange,
  placeholder = 'Select version',
  label = 'Version',
  disabled = false,
  multiple = true,
  archived = false,
}: VersionSelectorProps) {
  const { data: versions = [], isLoading } = useGetVersions(orgId, projectId, archived);

  const versionOptions = useMemo(
    () =>
      versions.map((version) => ({
        value: version.name,
        label: `${version.name}${version.released ? ' (Released)' : ''}`,
      })),
    [versions]
  );

  if (multiple) {
    return (
      <MultiSelect
        label={label}
        data={versionOptions}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        searchable
        disabled={disabled || isLoading}
        nothingFound="No versions found"
        withinPortal
      />
    );
  }

  return (
    <Select
      label={label}
      data={versionOptions}
      value={value[0] || null}
      onChange={(val) => onChange(val ? [val] : [])}
      placeholder={placeholder}
      searchable
      disabled={disabled || isLoading}
      nothingFound="No versions found"
      withinPortal
      clearable
    />
  );
}
